import engine from "store/src/store-engine";
import localStorage from "store/storages/localStorage";
import sessionStorage from "store/storages/sessionStorage";
import defaultPlugin from "store/plugins/defaults";
const plugins = [defaultPlugin];
const test = [localStorage];
const session = [sessionStorage];
const persistent = [localStorage, sessionStorage];
export const TestStore = engine.createStore(test, plugins);
export const LocalStore = engine.createStore(persistent, plugins);
export const SessionStore = engine.createStore(session, plugins);
export default LocalStore;
